// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.quill-editor {\n  position: relative;\n  padding-bottom: 40px;\n}\n.char-counter {\n  position: absolute;\n  bottom: -15px;\n  right: 0;\n  padding: 5px;\n  font-size: 14px;\n  color: #666;\n}\n", ""]);
// Exports
module.exports = exports;
